import React from 'react';

import { useTagState, useTagActions } from './TagContext';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';

import { denyTaggingRule } from './restApi';

const AllowedTaggingRulesTable = () => {
  const state = useTagState();
  const { onResponse, onError } = useTagActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Tag Type</Th>
          <Th>Taggable Type</Th>
          <Th />
        </Tr>
      </Thead>
      <Tbody>
        {(state?.tag?.allowedTaggingRules || []).map(taggingRule => (
          <Tr key={taggingRule.id}>
            <Td>{taggingRule.tagType}</Td>
            <Td>{taggingRule.taggableType}</Td>
            <Td>
              <ActionRow align="end">
                <Button
                  onClick={() => {
                    denyTaggingRule({
                      body: {
                        authenticityToken,
                        tagId: state?.tag?.id,
                        tagType: taggingRule.tagType,
                        taggableType: taggingRule.taggableType,
                      },
                      onResponse,
                      onError,
                    });
                  }}
                >
                  Deny Tagging Rule
                </Button>
              </ActionRow>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default AllowedTaggingRulesTable;
